import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneShape } from 'src/app/interfaces/gemstone-shape';

@Injectable({
  providedIn: 'root'
})
export class StoneShapesProviderService extends APIProviderService<GemstoneShape> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/Shapes`;
  }
}
